import Vue from 'vue';
import store from '@/store';
import UniqueId from 'vue-unique-id';
import PortalVue from 'portal-vue';

import 'whatwg-fetch';
import 'normalize.css';
import '@fortawesome/fontawesome-free/css/all.css';
import '@/styles/webfonts.scss';
import '@/styles/main.scss';
import 'intro.js/introjs.css';
import '@/styles/intro.theme.scss';

import '@/author/index.ts';
import '@/author/styles/styles.scss';

import '@/filters';
import 'focus-within-polyfill';
import VueIntro from 'vue-introjs';
import 'picturefill';
import router from '@/router';


// Don't warn about using the dev version of Vue in development
Vue.config.productionTip = process.env.NODE_ENV === 'production';

import Training from '@/components/Training.vue';
Vue.use(UniqueId);
Vue.use(PortalVue);
Vue.use(VueIntro,{
  scrollToElement: true
});

import '@/views/index.ts';


new Vue({
  router,
  store,
  render: h => h(Training)
}).$mount('#app');
